<template>
    <ul>
        <li v-for="product in products" :key="product.id">
            <router-link target="_blank" :to="`/product/${product.id}`">
                <div class="products-img"><img :src="host + product.figures.big" alt /> <span>see in catalog</span></div>
            </router-link>

            <label>{{ product.terms.name[$t("trad")].value }}</label>
        </li>
    </ul>
</template>

<script>
import Globals from "@/components/globals";

export default {
    props: {
        products: { type: Array, required: true }
    },
    data: () => ({ host: Globals.getBaseUrl() })
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/themes.scss";
ul {
    margin: 0;
    background-color: #e8e8e8;
    overflow-y: auto;
    padding: 20px 0;

    display: flex;
    flex-direction: column;
    align-items: center;

    > li {
        list-style: none;
        width: 190px;

        &:hover .products-img {
            img {
                border: 2px $color2 solid;
                margin: -2px;
            }
        }

        > label {
            margin-top: 8px;
            text-transform: uppercase;
            font-size: 12px;
            padding: 0 10px;
            display: block;
        }
        .products-img:hover {
            span {
                display: inline;
            }
        }
        .products-img {
            position: relative;
            img {
                width: 100%;
                box-sizing: content-box;
                border: 1px grey solid;
                margin: -1px;
            }
            span {
                font-weight: bold;
                font-family: "Roboto";
                display: none;
                position: absolute;
                bottom: 10px;
                left: 10px;
                border: unset;
                border-radius: 20px;
                background-color: $color2;
                color: white;
                text-transform: uppercase;
                padding: 2px 10px;
                text-decoration: none;
            }
        }
    }

    > li + li {
        margin-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// products-catalog.vue?49c8bb50